import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-subtle mt-20" data-testid="footer">
      <div className="container-msis py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 bg-navy text-white flex items-center justify-center font-display font-bold text-sm">M</div>
            <div className="font-display font-bold">MSIS</div>
          </div>
          <p className="text-sm text-slate2 max-w-xs">An evidence-based psychometric instrument to help management students choose the specialization that fits them best.</p>
        </div>
        <div>
          <div className="overline mb-3">Platform</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-slate2 hover:text-navy">About MSIS</Link></li>
            <li><Link to="/domains" className="text-slate2 hover:text-navy">9 Domains</Link></li>
            <li><Link to="/how-it-works" className="text-slate2 hover:text-navy">How It Works</Link></li>
            <li><Link to="/sample-report" className="text-slate2 hover:text-navy">Sample Report</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Audience</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/for-students" className="text-slate2 hover:text-navy">For Students</Link></li>
            <li><Link to="/institutions" className="text-slate2 hover:text-navy">For Institutions</Link></li>
            <li><Link to="/pricing" className="text-slate2 hover:text-navy">Pricing</Link></li>
            <li><Link to="/take-test" className="text-slate2 hover:text-navy">Take the Test</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Help</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/faq" className="text-slate2 hover:text-navy">FAQ</Link></li>
            <li><Link to="/contact" className="text-slate2 hover:text-navy">Contact</Link></li>
            <li><Link to="/privacy" className="text-slate2 hover:text-navy">Privacy &amp; Terms</Link></li>
            <li><Link to="/admin/login" className="text-slate2 hover:text-navy">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container-msis py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-xs text-slate2">© {new Date().getFullYear()} MSIS — Management Specialization Inclination Scale. All rights reserved.</p>
          <p className="text-xs text-slate2 font-mono">Evidence-based · Validated · Confidential</p>
        </div>
      </div>
    </footer>
  );
}
